import { cn } from '@sohanemon/utils';
import type * as React from 'react';
import { useState } from 'react';
import { ImageInspectorDialog } from './image-inspector-workspace';

type ImageInspectorProps = React.ComponentProps<'button'> & {
	/** Image opened in the inspector window. */
	src: string;
	filename?: string | null;
	size?: number | null;
	mimeType?: string | null;
	width?: number | null;
	height?: number | null;
};

/**
 * Click-to-open wrapper: renders `children` as the trigger and opens the
 * inspector window for `src`.
 */
export function ImageInspector({
	src,
	filename,
	size,
	mimeType,
	width,
	height,
	className,
	children,
	onClick,
	...props
}: ImageInspectorProps) {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<button
				type="button"
				className={cn(
					'inline-flex cursor-zoom-in appearance-none border-0 bg-transparent p-0 text-inherit focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
					className,
				)}
				onClick={(event) => {
					onClick?.(event);
					if (!event.defaultPrevented) setIsOpen(true);
				}}
				{...props}
			>
				{children}
			</button>
			<ImageInspectorDialog
				open={isOpen}
				onOpenChange={setIsOpen}
				asset={{ url: src, filename, size, mimeType, width, height }}
			/>
		</>
	);
}
